export default {
  MuiButtonBase: {
    disableRipple: true
  },
};
